<template>
  <el-row class="container">
    <el-col :span="3">
      <div>
        <el-button type="default" @click="goback" size="mini" class="mb-2" icon="el-icon-arrow-left">返回</el-button>
      </div>
      <el-tree class="filter-tree" highlight-current node-key="routeName" :current-node-key="$route.name" :data="mulu"
               default-expand-all @node-click="handleNodeClick" ref="tree"></el-tree>
    </el-col>
    <el-col :span="21">
      <h1>附件2 直观检查内容</h1>
      <table>
        <tr>
          <td>项目编号</td>
          <td>检测内容</td>
          <td>检测标准（规范）</td>
          <td>重要程度</td>
          <td>检测结果/数据</td>
        </tr>
        <template v-for="(item,i) in form">
          <tr :key="Math.random()+i">
            <td>{{ item.item_code }}</td>
            <td>{{ item.item_standard }}</td>
            <td>{{ item.item_content }}</td>
            <td>{{ item.item_level }}</td>
            <td>{{ item.item_result }}</td>
          </tr>
        </template>
      </table>
    </el-col>
  </el-row>
</template>

<script>
export default {
  data() {
    return {
      project_id: '',
      site_id: '',
      site_type: '',
      form: [],
      mulu: [
        {id: 1, label: '附件1', routeName: 'report_zg_fj1'},
        {id: 2, label: '附件2', routeName: 'report_zg_fj2'},
        {id: 3, label: '附件3', routeName: 'report_zg_fj3'},
        {id: 4, label: '意见', routeName: 'report_zg_yj'},
      ]
    }
  },
  methods: {
    goback() {
      this.$router.push({name: `site_${this.$route.params.site_type}_list`, params: this.$route.params})
    },
    async getData() {
      try {
        let res = await this.$Api.post('get_report_zg_fj2', {
          project_id: this.project_id,
          site_id: this.site_id,
          site_type: this.site_type
        })
        if (res) {
          for (let i = 0; i < res.length; ++i) {
            this.$set(this.form, i, res[i])
          }
        }
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    handleNodeClick(data) {
      if (this.$route.name !== data.routeName) {
        this.$router.push({
          name: data.routeName,
          params: {project_id: this.project_id, site_id: this.site_id, site_type: this.site_type}
        })
      }
    }
  },
  created() {
    this.project_id = this.$route.params.project_id
    this.site_id = this.$route.params.site_id
    this.site_type = this.$route.params.site_type

    this.getData()
  }
}
</script>

<style scoped>
.mb-2 {
  margin-bottom: 10px;
}

table {
  width: 98%;
}

table tr td h1 {
  font-size: 16px;
}

h1 {
  text-align: center;
}

table, table tr td {
  border: 1px solid black;
  border-collapse: collapse;
  text-align: left;
  vertical-align: middle !important;
  font-size: 18px;
}

table tr td {
  word-wrap: break-word;
  white-space: pre-wrap;
  word-break: break-all;
}

.filter-tree {
  margin-right: 10px;
}

::v-deep .el-tree-node__content {
  padding: 10px 0;
}
</style>

